const DASHBOARD_REFRESH_KEY = 'hairchitech_dashboard_refresh';
const DASHBOARD_REFRESH_EVENT = 'hairchitech:dashboard-refresh';

export const notifyDashboardRefresh = (detail = {}) => {
  const payload = {
    ts: Date.now(),
    ...detail,
  };

  if (typeof window === 'undefined') return payload;

  try {
    window.dispatchEvent(new CustomEvent(DASHBOARD_REFRESH_EVENT, { detail: payload }));
  } catch (_) {}

  try {
    localStorage.setItem(DASHBOARD_REFRESH_KEY, JSON.stringify(payload));
  } catch (_) {}

  return payload;
};

export const subscribeDashboardRefresh = (callback) => {
  if (typeof window === 'undefined') return () => {};

  const handleWindowEvent = (event) => {
    callback(event?.detail || null);
  };

  const handleStorageEvent = (event) => {
    if (event.key !== DASHBOARD_REFRESH_KEY || !event.newValue) return;
    try {
      callback(JSON.parse(event.newValue));
    } catch (_) {
      callback(null);
    }
  };

  window.addEventListener(DASHBOARD_REFRESH_EVENT, handleWindowEvent);
  window.addEventListener('storage', handleStorageEvent);

  return () => {
    window.removeEventListener(DASHBOARD_REFRESH_EVENT, handleWindowEvent);
    window.removeEventListener('storage', handleStorageEvent);
  };
};
